export function useTabsHelper() {
  return {
    updateBrowserTabCount(delta: number) {
      let count = this.totalOpenTabs();
      count = Math.max(0, count + delta);
      localStorage.setItem("open_tabs", count.toString());
    },

    totalOpenTabs: () => {
      return parseInt(localStorage.getItem("open_tabs") || "0");
    },
  };
}
